import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "../ui/button";

type Props = {
  open: boolean;
  name: string;
  role: "building" | "provider";
  isSubmitting?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export function JoinConfirmModal({ open, name, role, isSubmitting, onCancel, onConfirm }: Props) {
  const { t } = useTranslation();
  if (!open) return null;

  const repType = role === "building"
    ? t("selectRole.joinConfirm.repType.boardMember")
    : t("selectRole.joinConfirm.repType.rep");

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div className="w-full max-w-md bg-card rounded-xl border border-border p-6 shadow-lg">
        <h2 className="text-lg font-semibold text-foreground mb-2">
          {t("selectRole.joinConfirm.title")}
        </h2>
        <p className="text-sm text-muted-foreground mb-6">
          {t("selectRole.joinConfirm.text", { name, repType })}
        </p>
        <div className="flex flex-col-reverse sm:flex-row gap-2 sm:justify-end">
          <Button variant="outline" onClick={onCancel} disabled={isSubmitting}>
            {t("selectRole.joinConfirm.cancel")}
          </Button>
          <Button onClick={onConfirm} disabled={isSubmitting}>
            {t("selectRole.joinConfirm.confirm")}
          </Button>
        </div>
      </div>
    </div>
  );
}
